import { render, staticRenderFns } from "./InformationVolunteerNew.vue?vue&type=template&id=1556fa5a&scoped=true"
import script from "./InformationVolunteerNew.vue?vue&type=script&lang=js"
export * from "./InformationVolunteerNew.vue?vue&type=script&lang=js"
import style0 from "./InformationVolunteerNew.vue?vue&type=style&index=0&id=1556fa5a&prod&scoped=true&lang=css"
import style1 from "./InformationVolunteerNew.vue?vue&type=style&index=1&id=1556fa5a&prod&lang=css"
import style2 from "./InformationVolunteerNew.vue?vue&type=style&index=2&id=1556fa5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1556fa5a",
  null
  
)

export default component.exports